var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.result == 2)?_c('div',[_vm._v(" ダウンロードページが見つかりませんでした。 ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }